import { useMutation } from '@tanstack/react-query';
import { processInvite } from "../orgPanelApiCalls";


const useProcessInviteMutation = () => {
    return useMutation({
        mutationFn: async (variables) => {
            const data = await processInvite(variables.sharedCode);
            return data;
        },
    })
}

export { useProcessInviteMutation };